import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Dark } from 'themes';
import themeable from 'zignal-landscape/lib/themeable';
import Grid from 'zignal-landscape/lib/Grid';
import Heading from 'zignal-landscape/lib/Heading';
import BotIcon from 'zignal-landscape/lib/Icon/BotIcon';
import ThemeProvider from 'zignal-landscape/lib/ThemeProvider';

import { HEADER_TEXT, HEADER_DESCRIPTION } from './constants';
import * as actions from './BotIntelligence.ducks';
import BotBanner from './components/BotBanner';
import SearchFilters from './containers/SearchFilters';
import GraphContainer from './containers/GraphContainer';
import ActionsMenuPanel from './containers/ActionsMenuPanel';
import AddToGroupModal from './containers/AddToGroupModal';
import GraphDataExport from './containers/GraphDataExport';
import { getAdditionalFilterOptions } from './dataUtils';

export const mapStateToProps = (
  (state) => ({
    bannerMessage: state.BotIntelligence.Page.bannerMessage,
    selectedViewByOption: state.BotIntelligence.Page.selectedViewByOption,
    clusterNodesByType: state.BotIntelligence.Page.clusterNodesByType,
    clusterLinksByType: state.BotIntelligence.Page.clusterLinksByType,
    viewBy: state.BotIntelligence.Page.viewBy,
    filteredClusterNodes: state.BotIntelligence.Page.filteredClusterNodes
  })
);

export const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

class BotIntelligence extends Component {

  constructor(props) {
    super(props);

    this.setMenuBulkActionsRef = this.setMenuBulkActionsRef.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.handleRemoveCssOverrides = this.handleRemoveCssOverrides.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleDocumentClick);

    // this was set to display none in bot_intelligence_page.coffee
    // to avoid flickering of the previous page content
    window.$('#main-content').css({'display': 'block'});
    // Add popstate event listener for browser back button
    window.addEventListener('popstate', this.handleRemoveCssOverrides);
  }

  componentWillUnmount() {
    this.props.leaveBotIntelligenceRoom();
    this.props.clearState();
    document.removeEventListener('mousedown', this.handleDocumentClick);

    // Remove classes and style overrides
    this.handleRemoveCssOverrides();
    // remove event listener for browser back button
    window.removeEventListener('popstate', this.handleRemoveCssOverrides);
  }

  handleRemoveCssOverrides() {
    window.$('#main-content').removeClass('bot-intelligence-page');
    window.$('body').css('background-color', '#A0A6AE');
    window.$('html').removeClass('influence-intelligence-y-scroll');
  }

  setMenuBulkActionsRef(node) {
    this.menuBulkActionsRef = node;
  }

  handleDocumentClick({target}) {
    if (this.menuBulkActionsRef && !this.menuBulkActionsRef.contains(target)) {
      this.props.setClusterMenuButtonVisibility(false);
    }
  }

  render () {
    const {
      styles,
      bannerMessage,
      selectedViewByOption,
      clusterNodesByType,
      clusterLinksByType,
      viewBy,
      filteredClusterNodes,
      // passed from bot_intelligence_page
      campaigns,
      defaultCampaign,
      profileOptions,
      isUserDiscoverFeatureEnabled,
      queryParams,
      smartFilters,
      issueCategories,
      // actions
      clearBannerMessage,
      submitQuery,
      saveToGroup,
      setAddToGroupModalVisibility
    } = this.props;

    const clusterBy = selectedViewByOption.value;
    const clusterLinks = clusterLinksByType[clusterBy];
    const filteredClusters = filteredClusterNodes[clusterBy] || [];
    let clusterNodes = clusterNodesByType[clusterBy];

    const additionalFilterOptions = clusterBy === 'issues'
      ? getAdditionalFilterOptions(clusterNodes, { data: issueCategories, column: 'issues' })
      : getAdditionalFilterOptions(clusterNodes);

    if (clusterNodes && filteredClusters.length) {
      clusterNodes = clusterNodes.filter((node) => filteredClusters.includes(node.id));
    }

    return (
      <div>
        <div className={styles.BotIntelligenceTopShadow} />
        <div className={styles.BotIntelligenceLeftShadow} />
        <div className={styles.BotIntelligence}>
          <ThemeProvider theme={Dark}>
            <Grid fluid>
              <div className={styles.botIntelligenceContainer}>
                <BotBanner
                  bannerMessage={bannerMessage}
                  clearBannerMessage={clearBannerMessage}
                />
                <div>
                  <Heading>
                    <div className={styles.botIconAlignment}><BotIcon /></div><span>{HEADER_TEXT}</span>
                  </Heading>
                  <div className={styles.headerDescription}>{HEADER_DESCRIPTION}</div>
                </div>
                <SearchFilters
                  submitQuery={() => submitQuery({campaignId: defaultCampaign.value})}
                  profileOptions={profileOptions}
                  queryParams={queryParams}
                  smartFilters={smartFilters}
                  campaignId={defaultCampaign.value}
                />
                <AddToGroupModal
                  campaigns={campaigns}
                  defaultCampaign={defaultCampaign}
                  saveToGroup={saveToGroup}
                  setAddToGroupModalVisibility={setAddToGroupModalVisibility}
                />
                <div className={styles.graphSectionContainer}>
                  <GraphDataExport
                    clusterNodes={clusterNodes}
                    viewBy={viewBy}
                  />
                  <ActionsMenuPanel
                    clusterNodes={clusterNodes}
                    isUserDiscoverFeatureEnabled={isUserDiscoverFeatureEnabled}
                    setMenuBulkActionsRef={this.setMenuBulkActionsRef}
                    additionalFilterOptions={additionalFilterOptions}
                  />
                  <GraphContainer
                    clusterNodes={clusterNodes}
                    clusterLinks={clusterLinks}
                    isUserDiscoverFeatureEnabled={isUserDiscoverFeatureEnabled}
                  />
                </div>
              </div>
            </Grid>
          </ThemeProvider>
        </div>
      </div>
    );
  }
}

BotIntelligence.propTypes = {
  styles: PropTypes.object,
  bannerMessage: PropTypes.object,
  selectedViewByOption: PropTypes.object,
  clusterNodesByType: PropTypes.object,
  clusterLinksByType: PropTypes.object,
  viewBy: PropTypes.string.isRequired,
  filteredClusterNodes: PropTypes.object,
  // passed from bot_intelligence_page
  campaigns: PropTypes.array,
  defaultCampaign: PropTypes.object,
  profileOptions: PropTypes.array,
  isUserDiscoverFeatureEnabled: PropTypes.bool,
  queryParams: PropTypes.object,
  smartFilters: PropTypes.array,
  issueCategories: PropTypes.array,
  // actions
  submitQuery: PropTypes.func,
  clearBannerMessage: PropTypes.func,
  saveToGroup: PropTypes.func,
  setAddToGroupModalVisibility: PropTypes.func,
  setClusterMenuButtonVisibility: PropTypes.func,
  clearState: PropTypes.func,
  leaveBotIntelligenceRoom: PropTypes.func
};

BotIntelligence.defaultProps = {
  clusterNodesByType: {},
  clusterLinksByType: {},
  profileOptions: [],
  smartFilters: [],
  selectedViewByOption: {},
  defaultCampaign: {},
  filteredClusterNodes: {}
};

export default connect(mapStateToProps, actions, mergeProps)(themeable(BotIntelligence));
